import { render, staticRenderFns } from "./EditPIPCriteria.vue?vue&type=template&id=5c5197ec"
import script from "./EditPIPCriteria.vue?vue&type=script&lang=js"
export * from "./EditPIPCriteria.vue?vue&type=script&lang=js"
import style0 from "./EditPIPCriteria.vue?vue&type=style&index=0&id=5c5197ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports